import { Link } from "react-router";
import logoE50 from "@assets/events-awards/logo-e50.png";
import { E50_FOOTER_MENU } from "@e50/components/E50Constants";
import { EVENTS_AWARDS_E50_PATH } from "@events-awards/utils/constants";

import FooterMenuLinks from "./FooterMenuLinks";

/**
 * Component to display footer for desktop view in E50 pages
 */
const E50FooterDesktop = (): React.ReactElement => {
  return (
    <div
      className="grid w-full grid-cols-12 text-center"
      data-testid="e50-footer-desktop-component"
    >
      <div className="col-span-2 pl-0 pr-3">
        <Link to={EVENTS_AWARDS_E50_PATH} reloadDocument>
          <img
            src={logoE50}
            alt="Singapore Corporate Awards logo"
            width={124}
            height={166}
          />
        </Link>
      </div>

      <div className="col-span-5 pl-1 pr-3">
        <h3 className="mb-2 text-left font-poppins text-base font-medium">
          About Us
        </h3>

        <p className="pr-20 text-left leading-normal text-white">
          The E50 Awards seek to recognise the 50 most enterprising local,
          privately-held companies who have contributed to the economic
          development of Singapore, both locally and abroad.
        </p>
      </div>

      <div className="col-span-3 px-3">
        <p className="mb-4 text-left font-semibold">Sections</p>

        <div className="my-2 flex flex-row">
          <FooterMenuLinks
            items={E50_FOOTER_MENU.slice(0, 3)}
            className="space-y-4"
          />

          <FooterMenuLinks
            items={E50_FOOTER_MENU.slice(3, 6)}
            className="space-y-4 pl-20"
          />
        </div>
      </div>

      <div className="col-span-2 pl-5 pr-3">
        <p className="mb-4 text-left font-semibold">Quick Links</p>

        <FooterMenuLinks
          items={E50_FOOTER_MENU.slice(6, 9)}
          className="space-y-4"
        />
      </div>
    </div>
  );
};

export default E50FooterDesktop;
